import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

const UDAMAReportConfig = {
    auth: [...authRoles.admin],
    routes: [{ exact: true, path: '/uda-ma-report', component: FuseLoadable({ loader: () => import('./ViewUDAMAReportApp') }) }],
};

export default UDAMAReportConfig;
